<div class="container inventory-cart">
    <div class="row button-area button-area-top">
        <div class="col-xs-12  col-sm-4 col-md-6">
            <div class="row">
                <div class="col-xs-12 col-sm-10 col-md-10 ">
                    <h3><i class="fa fa-shopping-cart" aria-hidden="true"></i>
                        &nbsp;{{'shoppingCart.cartSummary.titles.shoppingCart' | translate}}</h3>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-6">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-6">
                    <a (click)="continueShopping()"
                        class="btn btn-primary btn-main btn-block btn-light">{{'shoppingCart.cartSummary.buttons.makeDifferentSelection'
                        | translate}}</a>
                </div>
                <div class="col-xs-12  col-sm-6 col-md-6">
                    <a (click)="checkout()"
                        class="btn btn-primary btn-main btn-block">{{'shoppingCart.cartSummary.buttons.checkout' |
                        translate}}</a>
                </div>
            </div>
        </div>
    </div>

    <!---
        <div class="row hidden-sm hidden-xs">
            <div class="col-sm-7 col-md-7">
                <b>ProductID</b>
            </div>
            <div class="col-sm-1 col-md-1">
                Quantity
            </div>
            <div class="col-sm-2 col-md-2" style="text-align:right">
                Price
            </div>
            <div class="col-sm-2 col-md-2" style="text-align:right">
                Shipping Cost
            </div>
        </div>
        <div *ngIf='cartItems && cartItems.length' class="inventory-cart-items">
            <div class="row summary-body" *ngFor='let item of cartItems'>
                <div class="col-sm-1 col-xs-2">
                    <img class="img-responsive" src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{item.imageUrl}}" />
                </div>
                <div class="col-sm-5 col-md-6 col-xs-7 bag-cart-name">
                    <p class="prod-name">
                        {{item.displayName}}
                    </p>
                    <p class="prod-ID">
                        {{item.productId}}
                    </p>
                </div>
                <div class="col-sm-2 col-md-1 col-xs-3" style="text-align:right;">
                    {{item.quantity}}
                    
                </div>
                <div class="col-sm-2 hidden-xs" style="text-align:right;">
                    {{item.price | currency:'USD':true:'1.2-2'}}
                </div>
                <div class="col-sm-2 col-xs-12 col-sm-push-0" style="text-align:right;">
                    {{item.quantity * 8.00 | currency:'USD':true:'1.2-2'}}
                </div>
            </div>
        </div>
            <div class="row summary-footer">
                <div class="col-sm-6 col-sm-push-6 col-xs-12">
                    <div class="row bag-total">
                        <div class="col-xs-8">
                            Subtotal
                        </div>
                        <div class="col-xs-4">
                            {{calcSub() | currency:'USD':true:'1.2-2'}}
                        </div>
                    </div>
                    <div class="row bag-total">
                        <div class="col-xs-8">
                            Tax
                        </div>
                        <div class="col-xs-4">
                            {{calcTax() | currency:'USD':true:'1.2-2'}}
                        </div>
                    </div>
                    <div class="row bag-total">
                        <div class="col-xs-8">
                            TOTAL COST
                        </div>
                        <div class="col-xs-4">
                            {{calcTotal() | currency:'USD':true:'1.2-2'}}
                        </div>
                    </div>
                </div>
            </div>
            -->
    <table class="table table-condensed table-responsive">
        <thead>
            <tr>
                <th>&nbsp;</th>
                <th>{{'shoppingCart.cartSummary.titles.sku' | translate}}</th>
                <th class="hidden-xs">{{'shoppingCart.cartSummary.titles.quantity' | translate}}</th>
                <th class="aright">{{'shoppingCart.cartSummary.titles.price' | translate}}</th>
                <th class="aright">{{'shoppingCart.cartSummary.titles.shippingCost' | translate}}</th>
            </tr>
        </thead>
        <tbody *ngIf='cartItems && cartItems.length'>
            <tr *ngFor='let item of cartItems'>
                <td>
                    <img width="60" src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{item.ImageUrl}}" />
                </td>
                <td class="bag-cart-name">
                    <p class="prod-name">
                        {{item.DisplayName}}
                    </p>
                    <p class="prod-ID">
                        {{item.ProductId}}
                    </p>
                </td>
                <td style="text-align:right;" class="hidden-xs">
                    {{item.Quantity}}

                </td>
                <td style="text-align:right;">
                    {{item.Price | currency:'USD':true:'1.2-2'}}
                </td>
                <td style="text-align:right;">
                    {{item.Quantity * 8.00 | currency:'USD':true:'1.2-2'}}
                </td>
            </tr>
        </tbody>
        <!--<tfoot> 
                        <tr>   
                            <th>&nbsp;</th>
                            <th  class="hidden-xs">&nbsp;</th>
                            <th>&nbsp;</th>
                            <th class="aright">$0.00</th>
                            <th class="aright">{{calcSub() | currency:'USD':true:'1.2-2'}}</th>
                        </tr>                    
                    </tfoot>-->
    </table>
    <hr class="no-margin" />


    <table class="inventory-cart-totals-area aright fright col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <tr>
            <td>{{'shoppingCart.cartSummary.titles.subtotal' | translate}}:</td>
            <td><span class="important">{{calcSub() | currency:'USD':true:'1.2-2'}}</span></td>
        </tr>
        <tr>
            <td>{{'shoppingCart.cartSummary.titles.taxTotal' | translate}}:</td>
            <td><span class="important">{{calcTax() | currency:'USD':true:'1.2-2'}}</span></td>
        </tr>
        <tr>
            <td>{{'shoppingCart.cartSummary.titles.total' | translate}}:</td>
            <td><span class="important">{{calcTotal() | currency:'USD':true:'1.2-2'}}</span></td>
        </tr>
    </table>
    <div class="clear"></div>
    <hr class="no-margin" />


    <div class="row button-area button-area-bottom">
        <div class="col-xs-12  col-sm-4 col-md-6">
            <div class="row">
                <div class="col-xs-12 col-sm-10 col-md-10">
                    <!-- <a (click)="clearCart()" class="btn btn-primary btn-main btn-block btn-light">Clear Cart</a> -->
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-6">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-6">
                    <a (click)="continueShopping()"
                        class="btn btn-primary btn-main btn-block btn-light">{{'shoppingCart.cartSummary.buttons.makeDifferentSelection'
                        | translate}}</a>
                </div>
                <div class="col-xs-12  col-sm-6 col-md-6">
                    <a (click)="checkout()"
                        class="btn btn-primary btn-main btn-block">{{'shoppingCart.cartSummary.buttons.checkout' |
                        translate}}</a>
                </div>
            </div>
        </div>
    </div>

    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true"
    [name]="'proccesOrder'">
    <p style="color: white"> {{'nuvei.paymentSection.spinner.processingOrder' | translate}} </p>
</ngx-spinner>